import { render, staticRenderFns } from "./ReportsDone.vue?vue&type=template&id=2b161572&scoped=true&"
import script from "./ReportsDone.vue?vue&type=script&lang=js&"
export * from "./ReportsDone.vue?vue&type=script&lang=js&"
import style0 from "./ReportsDone.vue?vue&type=style&index=0&id=2b161572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b161572",
  null
  
)

export default component.exports